var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskListClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.0144C15 25.1361 15.8429 27.171 17.3431 28.6713C18.8434 30.1716 20.8783 31.0144 23 31.0144C25.1217 31.0144 27.1566 30.1716 28.6569 28.6713C30.1571 27.171 31 25.1361 31 23.0144C31 20.8927 30.1571 18.8578 28.6569 17.3576C27.1566 15.8573 25.1217 15.0144 23 15.0144C20.8783 15.0144 18.8434 15.8573 17.3431 17.3576C15.8429 18.8578 15 20.8927 15 23.0144V23.0144Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.536 23.0142H23V19.4781",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.0144H14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.0144H11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.0144H11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31.0144H3C2.46957 31.0144 1.96086 30.8037 1.58579 30.4286C1.21071 30.0535 1 29.5448 1 29.0144V8.0144C1 7.48397 1.21071 6.97526 1.58579 6.60019C1.96086 6.22512 2.46957 6.0144 3 6.0144H8C8 4.68832 8.52678 3.41655 9.46447 2.47887C10.4021 1.54119 11.6739 1.0144 13 1.0144C14.3261 1.0144 15.5979 1.54119 16.5355 2.47887C17.4732 3.41655 18 4.68832 18 6.0144H23C23.5304 6.0144 24.0391 6.22512 24.4142 6.60019C24.7893 6.97526 25 7.48397 25 8.0144V11.0144",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.0144C13.0989 5.0144 13.1956 5.04373 13.2778 5.09867C13.36 5.15361 13.4241 5.2317 13.4619 5.32306C13.4998 5.41443 13.5097 5.51496 13.4904 5.61195C13.4711 5.70894 13.4235 5.79803 13.3536 5.86796C13.2836 5.93789 13.1945 5.98551 13.0975 6.0048C13.0006 6.02409 12.9 6.01419 12.8087 5.97635C12.7173 5.9385 12.6392 5.87442 12.5843 5.79219C12.5293 5.70997 12.5 5.6133 12.5 5.51441C12.5 5.3818 12.5527 5.25462 12.6464 5.16085C12.7402 5.06708 12.8674 5.0144 13 5.0144",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskListClock);
export default __webpack_public_path__ + "static/media/TaskListClock.06bf7d169856647ae7d6a8e4e2f3a168.svg";
export { ForwardRef as ReactComponent };